<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>作品分类</span>
        <el-button type="primary" size="small" @click="openDialog()">新增分类</el-button>
      </div>
      <p class="page-tip">分类将同步至用户端「我的作品」筛选 Tab、发布与编辑作品时的类型下拉。</p>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="分类名称" min-width="120" />
        <el-table-column label="图标" width="100">
          <template slot-scope="{ row }">
            <img v-if="row.icon" :src="resolveFileUrl(row.icon)" alt="" class="icon-thumb">
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80" />
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="{ row }">{{ labelOf(COMMON_STATUS, row.status) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
            <el-button type="text" size="small" class="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="form.id ? '编辑作品分类' : '新增作品分类'" :visible.sync="visible" width="460px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="form.name" placeholder="如：短视频、摄影作品" />
        </el-form-item>
        <el-form-item label="图标">
          <image-upload v-model="form.icon" biz-type="work_category" button-text="上传图标" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortOrder" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width: 100%">
            <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getWorkCategories, saveWorkCategory, deleteWorkCategory } from '@/api/admin'
import ImageUpload from '@/components/admin/ImageUpload.vue'
import { COMMON_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'
import { resolveFileUrl } from '@/utils/fileUrl'

export default {
  name: 'CreationsCategories',
  components: { ImageUpload },
  data() {
    return {
      COMMON_STATUS,
      loading: false,
      list: [],
      visible: false,
      submitting: false,
      form: { id: null, name: '', icon: '', sortOrder: 0, status: 1 },
      rules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(COMMON_STATUS)
    }
  },
  created() {
    this.loadCategories()
  },
  methods: {
    labelOf,
    resolveFileUrl,
    async loadCategories() {
      this.loading = true
      try {
        this.list = await getWorkCategories() || []
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    openDialog(row) {
      this.form = row
        ? { ...row }
        : { id: null, name: '', icon: '', sortOrder: 0, status: 1 }
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await saveWorkCategory(this.form)
          this.$message.success('保存成功')
          this.visible = false
          this.loadCategories()
        } catch (e) {
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确定删除作品分类「${row.name}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteWorkCategory(row.id)
          this.$message.success('已删除')
          this.loadCategories()
        }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-tip {
  margin: 0 0 16px;
  font-size: 13px;
  color: #909399;
}
.icon-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.text-muted {
  color: #c0c4cc;
}
.danger {
  color: #f56c6c;
}
</style>
